import { render, staticRenderFns } from "./VacationTable.vue?vue&type=template&id=4bf68533"
import script from "./VacationTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./VacationTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports